import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../../ApiService';
import { JobHiringMemberList } from '../../../../entities/v1/applicant_tracking/JobHiringMemberList';

export class JobHiringMemberService {
  public static listRecruiterJobsForUser(
    userId: number,
  ): Promise<JobHiringMemberList> {
    return ApiService.get<JobHiringMemberList>(
      `/api/v1/applicant_tracking/job_hiring_members/recruiter_jobs`,
      snakecaseKeys({ userId }),
    );
  }
}
